import { Record as record } from 'immutable';

import UserPreferences from './UserPreferences';
import ValidationMixin from '../ValidationMixin';
import validators from '../../validation';

const defaults = {
    preferences: new UserPreferences(),
    isOver16: false,
    telephoneNumber: null
};

class EditPreferencesForm extends record(defaults) {
    static fromUser (user) {
        return new EditPreferencesForm({
            preferences: user.preferences || new UserPreferences(),
            isOver16: user.isOver16,
            telephoneNumber: user.telephoneNumber
        });
    }

    getSchema () {
        let schema = {};
        if (this.preferences.isSomeSmsPrefSetToTrue()) {
            schema = Object.assign(schema, {
                telephoneNumber: validators.phone().required()
            });
        }
        return schema;
    }

    hasBeenEdited (user) {
        const preferencesChanged = this.preferences.hasDifferentPreferencesTo(user.preferences || new UserPreferences());
        const over16Changed = this.isOver16 !== !!user.isOver16;
        const numberChanged = this.telephoneNumber !== user.telephoneNumber;
        return preferencesChanged || over16Changed || numberChanged;
    }
}

Object.assign(EditPreferencesForm.prototype, ValidationMixin);

export default EditPreferencesForm;
